// extracted by mini-css-extract-plugin
module.exports = {"custom-element-preview-container":"_14FaR","customElementPreviewContainer":"_14FaR","premium-banner":"_2lPNq","premiumBanner":"_2lPNq"};